import { Component, NgZone, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { first } from 'rxjs/operators';
import { Backend } from '../_models/backend';
import { RouterConstants } from '../_models/router-constants';
import { GoogleLoginProvider, SocialAuthService } from '@abacritt/angularx-social-login';
import { environment } from '../../environments/environment';
import LoginRequest = Backend.LoginRequest;

declare var loginObj: LoginComponent;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  loginAsLabel = 'LOGIN.LOGIN_AS_TEACHER';
  loginRequest: LoginRequest = { username: '', password: '', oauth: false };

  constructor(private route: ActivatedRoute, private router: Router, private authService: AuthService,
              private socialAuthService: SocialAuthService, private ngZone: NgZone) {
    loginObj = this;


    if (this.router.url.includes(RouterConstants.SCHOOL_ADMIN)) {
      this.loginAsLabel = 'LOGIN.LOGIN_AS_SCHOOL_ADMIN';
      if (this.authService.currentUserValue && !this.authService.isSchoolAdmin()) {
        this.authService.clearUser();
      }
    } else if (this.router.url.includes(RouterConstants.ADMIN)) {
      this.loginAsLabel = 'LOGIN.LOGIN_AS_ADMIN';
      if (this.authService.currentUserValue && !this.authService.isAdmin()) {
        this.authService.clearUser();
      }
    }

    // redirect to home if already logged in
    if (this.authService.currentUserValue) {
      this.router.navigate(['/'], {replaceUrl: true});
    }
  }

  ngOnInit(): void {
    this.socialAuthService.authState.subscribe((user) => {
      console.log(user);
      this.onSubmit({ username: user.email, password: user.idToken, oauth: true });
    });
  }

  onSubmit(loginRequest: LoginRequest): void {
    this.authService.login(loginRequest, this.router.url)
      .pipe(first())
      .subscribe({
        next: () => {
          // get return url from route parameters or default to '/'
          const returnUrl = this.route.snapshot.queryParams.returnUrl || '/';
          this.router.navigate([returnUrl], {replaceUrl: true});
        }
      });
  }

  signInWithGoogle() {
    this.socialAuthService.signIn(GoogleLoginProvider.PROVIDER_ID);
  }

  handleCredentialResponse(response: any) {
    function b64DecodeUnicode(str: string) {
      // Going backwards: from bytestream, to percent-encoding, to original string.
      return decodeURIComponent(atob(str).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));
    }

    function decodeJwtResponse(credential: string) {
      return JSON.parse(b64DecodeUnicode(credential.split('.')[1]));
    }

    // to decode the credential response.
    const user = decodeJwtResponse(response.credential);

    console.log("ID: " + user.sub);
    console.log('Full Name: ' + user.name);
    console.log('Given Name: ' + user.given_name);
    console.log('Family Name: ' + user.family_name);
    console.log("Image URL: " + user.picture);
    console.log("Email: " + user.email);

    console.log(user);
    this.ngZone.run(() => { this.onSubmit({ username: user.email, password: response.credential, oauth: true }) });
  }

  signOut(): void {
    this.socialAuthService.signOut();
  }

  refreshToken(): void {
    this.socialAuthService.refreshAuthToken(GoogleLoginProvider.PROVIDER_ID);
  }

  getWebAppClientId(): string {
    return environment.webapp_client_id;
  }

}
